import { render } from "./LiquidityMining.vue?vue&type=template&id=10a9122d&scoped=true"
import script from "./LiquidityMining.vue?vue&type=script&lang=js"
export * from "./LiquidityMining.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-10a9122d"

export default script